export default {"src":"/_next/static/media/UTHR.45243110.svg","height":18,"width":18};